import { render, staticRenderFns } from "./RegistrationContract.vue?vue&type=template&id=443d6842&scoped=true&"
import script from "./RegistrationContract.vue?vue&type=script&lang=js&"
export * from "./RegistrationContract.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationContract.vue?vue&type=style&index=0&id=443d6842&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443d6842",
  null
  
)

export default component.exports